export const DRAFT_SCHEME = "draft-scheme-";